<template>
  <v-card class="mx-3 pa-4" elevation="0">
    <v-card-text class="d-flex flex-wrap">
      <!-- Catégorie & Types de producteurs -->
      <v-row>
        <v-col>
          <div class="field-name">
            {{ $filters.capitalize($t("part_categories.label")) }}
          </div>
          <p class="text-body-1 text--primary">
            {{ $store.state.stock_parts.edit.category?.name || '-' }}
          </p>
        </v-col>
        <v-col>
          <div class="field-name">
            {{ $filters.capitalize($t("producer_types.label", 1)) }}
          </div>
          <ul v-if="$store.state.stock_parts.edit.category?.producer_types?.length">
            <li
              v-for="producer in $store.state.stock_parts.edit.category.producer_types"
              :key="producer.pk"
            >
              {{ $filters.capitalize(producer.name) }}
            </li>
          </ul>
          <ul v-else>
            <li>
              {{ $filters.capitalize($t("part_edition.generic_type")) }}
            </li>
          </ul>
        </v-col>
      </v-row>

      <!-- Noms & Référence -->
      <v-row>
        <v-col>
          <div class="field-name">
            {{ $filters.capitalize($t("stock_parts.name")) }}
          </div>
          <p class="text-body-1 text--primary">
            {{ $store.state.stock_parts.edit.name || '-' }}
          </p>
        </v-col>
        <v-col>
          <div class="field-name">
            {{ $filters.capitalize($t("stock_parts.name_en")) }}
          </div>
          <p class="text-body-1 text--primary">
            {{ $store.state.stock_parts.edit.name_en || '-' }}
          </p>
        </v-col>
        <v-col>
          <div class="field-name">
            {{ $filters.capitalize($t("stock_parts.ref")) }}
          </div>
          <p class="text-body-1 text--primary">
            {{ $store.state.stock_parts.edit.ref || '-' }}
          </p>
        </v-col>
      </v-row>

      <!-- Champ Categorization -->
      <v-row>
        <v-col>
          <div class="field-name">
            {{ $filters.capitalize($t("stock_parts.categorization")) }}
          </div>
          <p class="text-body-1 text--primary">
            {{ $store.state.stock_parts.edit.categorization ?? '-' }}
          </p>
        </v-col>
      </v-row>

      <!-- Unité & Prix -->
      <v-row>
        <v-col>
          <div class="field-name">
            {{ $filters.capitalize($t("unity.label")) }}
          </div>
          <p class="text-body-1 text--primary">
            {{
              $filters.capitalize(
                $filters.unityFilter($store.state.stock_parts.edit.unity)
              )
            }}
          </p>
        </v-col>
        <v-col>
          <div class="field-name">
            {{ $filters.capitalize($t("stock_parts.price")) }}
          </div>
          <p class="text-body-1 text--primary">
            {{
              $filters.formatPrice(
                $store.state.stock_parts.edit.price,
                $store.state.stock_parts.edit.price_currency
              )
            }}
          </p>
        </v-col>
        <v-col>
          <div class="field-name">
            {{ $filters.capitalize($t("stock_parts.resell_price")) }}
          </div>
          <p class="text-body-1 text--primary">
            {{
              $filters.formatPrice(
                $store.state.stock_parts.edit.resell_price,
                $store.state.stock_parts.edit.resell_price_currency
              )
            }}
          </p>
        </v-col>
        <v-col>
          <div class="field-name">
            {{ $filters.capitalize($t("stock_parts.avg_price")) }}
          </div>
          <p class="text-body-1 text--primary">
            {{
              $filters.formatPrice(
                $store.state.stock_parts.edit.avg_price,
                $store.state.stock_parts.edit.avg_price_currency
              )
            }}
          </p>
        </v-col>
      </v-row>

      <!-- Fournisseurs & Local -->
      <v-row>
        <v-col>
          <div class="field-name">
            {{ $filters.capitalize($t("suppliers.label", 10)) }}
          </div>
          <ul v-if="$store.state.stock_parts.edit.suppliers?.length">
            <li
              v-for="supplier in $store.state.stock_parts.edit.suppliers"
              :key="supplier.pk"
            >
              {{ $filters.capitalize(supplier.name) }}
            </li>
          </ul>
          <p v-else>-</p>
        </v-col>
        <v-col>
          <div class="field-name">
            {{ $filters.capitalize($t("stock_parts.is_locally_bought")) }}
          </div>
          <p class="text-body-1 text--primary">
            {{
              $filters.capitalize(
                $t(
                  $store.state.stock_parts.edit.is_locally_bought
                    ? "stock_parts.is_locally_bought_.true"
                    : "stock_parts.is_locally_bought_.false"
                )
              )
            }}
          </p>
        </v-col>
        <v-col>
          <div class="field-name">
            {{ $filters.capitalize($t("stock_parts.image")) }}
          </div>
          <v-img
            :src="$store.state.stock_parts.edit.image"
            style="border: 1px dashed grey"
            max-height="210"
            max-width="280"
            placeholder="static/camera_off.png"
            contain
          />
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
export default {};
</script>

<style scoped>
.field-name {
  font-weight: 600;
  font-size: 0.9rem;
  margin-bottom: 4px;
}
</style>

